import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

/**
 * 路由守卫组件
 *
 * 用于保护需要登录才能访问的页面。
 * 未登录用户将被重定向到登录页。
 */
function ProtectedRoute(): JSX.Element {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const initialized = useAuthStore((state) => state.initialized);
  const location = useLocation();

  // 加载中时显示空内容，避免闪烁
  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // 保存用户尝试访问的路径，登录后可重定向回来
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 已登录用户渲染子路由
  return <Outlet />;
}

export default ProtectedRoute;
